<template>
    <div>
        <div class="row m-0">
            <div class="col-12">
                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 pt-2 mt-1 mb-1">
                    <div>
                        <h5 class="title mt-2">Packs SMS vendus</h5>
                    </div>
                </div>
            </div>
        </div>
        <LoaderComponent v-if="loading" />
        <div class="row m-0" v-else>
            <div class="col-12">
                <div class="border-light b-radius-20 p-4 mb-3">
                    <form @submit="fetchData">
                        Entre le&nbsp;
                        <datepicker
                            class="d-inline-block"
                            format="dd/MM/yyyy"
                            input-class="form-control"
                            :monday-first="true"
                            :language="fr"
                            v-model="filter.from_date"></datepicker>
                        &nbsp;et le&nbsp;
                        <datepicker
                            class="d-inline-block"
                            format="dd/MM/yyyy"
                            input-class="form-control"
                            :monday-first="true"
                            :language="fr"
                            v-model="filter.to_date"></datepicker>
                        <button type="submit" class="btn btn-sm btn-success btn-circle ms-2">Rechercher</button>
                        <button @click="resetFilter" type="button" class="btn btn-sm btn-success btn-circle ms-2">Réinitialiser les filtres</button>
                    </form>
                </div>
            </div>
            <div class="col-12" v-if="invoices">
                <div class="border-light b-radius-20 p-4 mb-3">
                    <div class="d-flex justify-content-between">
                        <div>
                            <strong class="d-block mt-1">Total : {{ invoices.length }}</strong>
                            <strong class="d-block mt-1">CA Total : {{ formatCurrency(totalAmount / 100) }}</strong>
                        </div>
                        <div>
                            <a target="_blank" :href="exportUrl"><button class="btn btn-sm btn-success btn-circle">Export excel</button></a>
                        </div>
                    </div>
                </div>
                <table class="table table-sm table-striped border-bottom">
                    <thead class="border-bottom">
                        <tr>
                            <th>Compte admin</th>
                            <th>Offre</th>
                            <th>Prix HT</th>
                            <th>Date de paiement</th>
                            <th>Crédits restants</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="invoice in invoices" :key="invoice.id">
                            <td style="text-transform: capitalize">
                                <span v-if="invoice.owner">{{ invoice.owner.firstname }} {{ invoice.owner.lastname }}</span>
                                <span v-else class="text-danger">Owner inexistant</span>
                            </td>
                            <td>
                                <span class="d-block" v-for="line in invoice.lines.data" :key="line.id">{{ line.description }}</span>
                            </td>
                            <td>{{ formatCurrency(getInvoiceAmount(invoice) / 100) }}</td>
                            <td>{{ moment.unix(invoice.status_transitions.paid_at).format("DD MMM Y") }}</td>
                            <td>
                                <span v-if="!invoice.owner">--</span>
                                <span v-else-if="getSmsCount(invoice.owner.id) !== null">{{ getSmsCount(invoice.owner.id) }}</span>
                                <span v-else>Chargement ...</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoaderComponent from "../LoaderComponent";
import Datepicker from "vuejs-datepicker";
import { fr } from "vuejs-datepicker/dist/locale";

const defaultFilter = {
    from_date: null,
    to_date: null,
};

export default {
    data() {
        return {
            loading: false,
            filter: _.cloneDeep(defaultFilter),
            fr,
            moment,
            invoices: null,
            smsCredits: [],
        };
    },
    computed: {
        exportUrl() {
            let url = "/api/admin/exports/sold_sms_packs?";
            if (this.filter.from_date) url += "&from_date=" + moment(this.filter.from_date).format("Y-MM-DD");
            if (this.filter.to_date) url += "&to_date=" + moment(this.filter.to_date).format("Y-MM-DD");
            return url;
        },
        totalAmount() {
            let amount = 0;
            if (this.invoices) this.invoices.forEach((invoice) => (amount += this.getInvoiceAmount(invoice)));
            return amount;
        },
        distinctOwnersIds() {
            if (!this.invoices) return [];
            let ids = this.invoices.map((i) => (i.owner ? i.owner.id : null));
            return ids.filter((id, i) => id && ids.indexOf(id) === i);
        },
    },
    methods: {
        getSmsCount(user_id) {
            let count = this.smsCredits.find((s) => s.user_id == user_id);
            if (count) return count.count;
            return null;
        },
        fetchSmsCount(user_id) {
            axios
                .get(`/api/sms/getCreditCount?user_id=${user_id}`)
                .then((response) => {
                    this.smsCredits.push({
                        user_id,
                        count: response.data,
                    });
                })
                .catch((error) => {});
        },
        fetchAllCreditCount() {
            this.distinctOwnersIds.forEach((id) => {
                this.fetchSmsCount(id);
            });
        },
        getInvoiceAmount(invoice) {
            let amount = 0;
            invoice.lines.data.forEach((l) => (amount += l.amount));
            return amount;
        },
        resetFilter(e) {
            if (e) e.preventDefault();
            this.filter = _.cloneDeep(defaultFilter);
        },
        fetchData(e) {
            if (e) e.preventDefault();

            this.invoices = null;
            this.loading = true;

            let params = {};
            if (this.filter.from_date) params.from_date = moment(this.filter.from_date).format("Y-MM-DD");
            if (this.filter.to_date) params.to_date = moment(this.filter.to_date).format("Y-MM-DD");
            this.$store
                .dispatch("admin/fetchInvoices", { params, type: "sms_packs" })
                .then((response) => {
                    this.loading = false;
                    this.invoices = Object.values(response.data.data);
                    this.fetchAllCreditCount();
                })
                .catch((error) => {
                    this.loading = false;
                    let errorMsg = "Une erreur est survenue";
                    if (error.response && error.response.data.message) errorMsg = error.response.data.message;
                    else if (error.message) errorMsg = error.message;
                    this.$notify({
                        group: "notification",
                        type: "error",
                        title: errorMsg,
                    });
                });
        },
    },
    components: {
        LoaderComponent,
        Datepicker,
    },
    created() {},
};
</script>
